import RichUpdatesItemShareAlert from './RichUpdatesItemShareAlert';

export default RichUpdatesItemShareAlert;



// WEBPACK FOOTER //
// ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShareAlert/index.tsx